import React, { useState, useEffect } from "react";

import Highlight, { defaultProps } from "prism-react-renderer";
import github from "prism-react-renderer/themes/github";


const PrismCodeDisplayer = ({ codeToDisplay, languageToUse = "javascript" }) => {


  return (
    <>
      <Highlight {...defaultProps} theme={github} code={codeToDisplay} language={languageToUse}>
        {({ style, tokens, getLineProps, getTokenProps }) => (
          <pre style={{ ...style, padding: "15px", borderRadius: "5px", overflowX: "auto" }}>
            {tokens.map((line, i) => (
              <div key={i} {...getLineProps({ line, key: i })}>
                {line.map((token, key) => (
                  <span key={key} {...getTokenProps({ token, key })} />
                ))}
              </div>
            ))}
          </pre>
        )}
      </Highlight>
    </>
  );


};


export default PrismCodeDisplayer;